import { Component, Input } from '@angular/core';
import { Queue } from '@app/core/interfaces/c5/acd/queue';
import { ContextSwitchTypeaheadEntry } from '@app/menu/components/context-switcher/context-switch-typeahead-entry';
import { MenuService } from '@app/menu/services/menu.service';
import { TypeaheadEntry } from '@app/shared/services/typeahead-basket.service';

@Component({
  selector: 'portal-acd-switcher',
  templateUrl: './acd-switcher.component.html',
  styles: [],
  standalone: false,
})
export class AcdSwitcherComponent {
  @Input()
  queue: Queue;

  @Input()
  queues: TypeaheadEntry<number>[];

  constructor(private menuService: MenuService) {}

  switchRoute(typeaheadEntry: ContextSwitchTypeaheadEntry) {
    if (typeaheadEntry.value !== this.queue.id) {
      this.menuService.switch('queueId', {
        queueId: typeaheadEntry.value,
      });
    }
  }
}
